import axios from "axios";

const API_URL = "https://agro-nexus-prod.vercel.app/api";

export const loginWithEmail = async (email, password) => {
  try {
    const res = await axios.post(`${API_URL}/login`, { email, password });
    return res;
  } catch (err) {
    throw err;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem("token");
};

export const axiosAuth = axios.create({
  baseURL: API_URL,
});

axiosAuth.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
